import { render, staticRenderFns } from "./Regiones.vue?vue&type=template&id=b7c1feb8&"
import script from "./Regiones.vue?vue&type=script&lang=js&"
export * from "./Regiones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports